import React, { useState, useEffect } from 'react';
import { newsService } from '../services/api';

export default function News() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadNews = async () => {
      try {
        const response = await newsService.getNews();
        setNews(response.data);
      } catch (err) {
        console.error('Error loading news:', err);
        setError('Error al cargar las noticias');
      } finally {
        setLoading(false);
      }
    };

    loadNews();
  }, []);
  if (loading) return <div className="text-center py-12">Cargando noticias...</div>;
  if (error) return <div className="text-center py-12 text-red-600">{error}</div>;
  if (!news?.length) return null;

  return (
    <section className='max-w-6xl mx-auto px-4 py-12'>
      <h2 className='text-2xl font-bold mb-6'>Noticias y Multimedia</h2>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        {news.map(n => (
          <article key={n.id} className='border rounded p-4 bg-white'>
            <div className='text-sm text-gray-500'>{n.date}</div>
            <h3 className='font-semibold mt-2'>{n.title}</h3>
            <p className='mt-2 text-gray-600'>{n.excerpt}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
